/** Thin vertical divider separating top-bar sections. */
const NavDivider = ({ isDark }) => (
  <div
    className={`w-px h-7 shrink-0 ${isDark ? "bg-white/10" : "bg-border-light"}`}
    aria-hidden="true"
  />
);

export default NavDivider;
